import { Component } from '@angular/core';
import { NavigationTrackerService } from './core/services/navigation-tracker.service';
import { SeoService } from './core/services/seo.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = environment.name;

  constructor(
    private navigationTracker: NavigationTrackerService,
    private seoService: SeoService
  ) {
    this.seoService.init();
  }
}

